<template>
  <a-modal
    :title="audit ? '业务费审批' : '业务费详情'"
    class="gufiiguy"
    :visible="is_show"
    style="top: 20px"
    width="50%"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="is_show = false"
  >
    <template slot="footer">
      <a-button type="primary" @click="downloadData" style="float: left"> 导出 </a-button>
      <a-button key="back" @click="is_show = false"> 取消 </a-button>
      <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
      <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
      <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
    </template>
    <div ref="sadsada">
      <a-form :form="form" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
        <div class="title">
          <span>基本信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="审批标题"
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ mdl.title }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="抄 送 人 " :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.ccName }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="隶属公司">
                <span>{{ mdl.companyName }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="隶属部门">
                <span>{{ mdl.deptName }}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="title">
          <span>业务费明细</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="24">
              <a-form-item label="付款单号" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.applyCode }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="项目编号">
                <span>{{ mdl.projectCode }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="标　　题">
                <span>{{ mdl.title }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="申 请 人 ">
                <span>{{ mdl.applyUserName }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="项目总金额">
                <span>{{ mdl.projectPrice }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="支付对象">
                <span>{{ mdl.paymentObject }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="新老业务">
                <span>{{ mdl.ifOld==0?'新业务':'续签业务' }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="业务费">
                <span>{{ mdl.commission?mdl.commission:0 }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="分包费">
                <span>{{ mdl.subprojectFee?mdl.subprojectFee:0 }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="其他费用">
                <span>{{ mdl.otherFee?mdl.otherFee:0 }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="项目名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.projectName }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="备　　注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.remark }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="报 价 单 " :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <div
                  class="view_path"
                  @click="previewFile(item)"
                  v-for="(item, index) in mdl.sysAttachments"
                  :key="index"
                >
                  {{ item.name }}
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="title" v-if="!audit && recordNumber==1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit && recordNumber==1">
          <auditModel ref="auditModel"></auditModel>
        </div>
      </a-form>
    </div>
    <!-- 撤销提示 -->
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" v-if="isRouterAlive" />
  </a-modal>
</template>
<script>
import { downLoadPdf  } from '@/utils/index'
import auditModel from './audit.vue'
import { getBusinessFeeApply, auditTask, act_task_audit, business_fee_apply_downlodPdf } from '@/api/activiti'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import Watermark from '../../../utils/watermark'
import { download_file_java } from '@/utils/request'
import { resolveBlob} from '@/utils/index'
 const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
export default {
  name: 'LeaveModal',
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    transferModal,
    auditModel
  },
  data() {
    return {
      recordNumber: 0,
      isRouterAlive: true,
      companylist: [],
      deptlist: [],
      plainOptions: [],
      visible: false,
      result: '',
      comment: '', //驳回原因
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      confirmLoading: false,
      is_show: false,
      is_revocation: false,
      mdl: {},
      options: [],
      dateFormat: 'YYYY-MM-DD HH:mm',
      formData: {},
      record: '',
      form: this.$form.createForm(this),
    }
  },
  methods: {
    	//导出
		downloadData() {
			downLoadPdf('/act/business_fee_apply/downlodPdf?businessKey=' + this.record.businessKey,)
    },
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    download() {
      // http request 拦截器
// axios.interceptors.request.use(
//  config => {
//   if (store.state.token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
//    config.headers.Authorization = `token ${store.state.token}`;
//   }
//   return config;
//  },
//  err => {
//   return Promise.reject(err);
//  })
      business_fee_apply_downlodPdf({
        businessKey: this.record.businessKey,
      }).then((res) => {
       window.open(exportBaseUrl + '/file/download?path=' + res.data)
      })
    }, //预览文件
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },
    // //预览文件
    // previewFile(file) {
    // 	console.log(file)
    // 	window.open(file.preUrl)
    // },
    show(record) {
      this.recordNumber = record.recordNumber
      console.log('1111111111111111111111111111111111111')
      this.record = record
      // record 是任务 如果只是查看可以只传入一个businessKey
      if (this.audit) {
        this.formData = Object.assign({
          taskId: record.id,
          procInstId: record.procInstId,
          procName: record.processDefName,
          businessKey: record.businessKey,
          procDefKey: record.processDefKey,
          applyer: record.applyer,
        })
      }
      getBusinessFeeApply(record.businessKey).then((res) => {
        if (res.code === 200) {
          const { type } = res.data
          this.mdl = Object.assign(res.data)
          this.is_show = true
          this.$nextTick(() => {
            Watermark.set('安联云管家', this.$refs.sadsada)
             if(!this.audit && this.recordNumber == 1) {
                 this.$refs.auditModel.show(record)
               }
          })
        }
      })
    },
    handleSubmit(result) {
      this.confirmLoading = true
      const formData = this.formData
      formData.result = result
      auditTask(formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.$emit('ok')
            this.is_show = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
          this.actTask()
        }
      } else if (this.result == 2) {
        this.actTask()
      }
    },
    actTask() {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: this.result,
        businessKey: this.record.businessKey,
        comment: this.comment,
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.is_show = false
        this.is_revocation = false
      })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
    },
  },
  watch: {
    /*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
  },
}
</script>
<style lang='less' scoped>
/deep/ .ant-input-disabled {
  color: #000;
  background-color: #fff;
}

/deep/ .ant-select-disabled {
  color: #000;
}

/deep/ .ant-select-selection {
  background-color: #fff;
}

.ant-form-item-control {
  line-height: 1;
}

.spanClass {
  font-size: 16px;
}

.view_path {
  color: #00a2fd;
}
</style>
